/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ConfigurationForCostAnomalyNotification extends models.ConfigurationForNotifications {
    getFixupPrototypeFunction() { return ConfigurationForCostAnomalyNotification.fixupPrototype; }

    static newInstance(model: Partial<ConfigurationForCostAnomalyNotification>): ConfigurationForCostAnomalyNotification {
        let obj = Object.assign(new ConfigurationForCostAnomalyNotification(), model);
        ConfigurationForCostAnomalyNotification.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ConfigurationForCostAnomalyNotification>): ConfigurationForCostAnomalyNotification {
        if (!model) return null;
        return ConfigurationForCostAnomalyNotification.newInstance(<ConfigurationForCostAnomalyNotification> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ConfigurationForCostAnomalyNotification) {
        if (!obj) return;

        models.ConfigurationForCostAnomalyNotification.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ConfigurationForCostAnomalyNotification): boolean {
        if (models.ConfigurationForNotifications.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ConfigurationForCostAnomalyNotification.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Specifies whether realtime notification enabled or not.
     */
    enable_realtime_notification: boolean;

    /**
     * Specifies whether daily summary notification enabled or not.
     */
    enable_daily_summary_notification: boolean;

}
